import React from 'react';

import { ListCard } from '../../helpers/list-page/interfaces/list-card.interface';
import ImageWrapper from '../image-wrapper/Image-wrapper';

interface CardLogoProps {
  card: ListCard;
  className?: string;
}

export const CardLogo = ({ card, className }: CardLogoProps) => {
  if (card.logo) {
    const classNames = className?.length
      ? className
      : '!absolute top-6 left-6 w-14 h-14 bg-brand-white rounded-md';
    return (
      <ImageWrapper
        gatsbyImageData={card.logo?.gatsbyImageData}
        file={card.logo?.file}
        svg={card.logo?.svg}
        alt={card.logo?.description ? card.logo.description : ''}
        className={classNames}
        imgClassName="!object-contain"
      />
    );
  }
  return null;
};
